<template>
  <router-view/>
</template>

<script>
export default {
  name: 'SubroutesTemplate',
}
</script>
